import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import { Icon24 } from 'builder/components/Icon'
import Tooltip from 'builder/components/Tooltip/Tooltip'

export const TipsTitle = styled.div`
  ${Typography.Caption};
  color: ${Colors.Blue50};
  ${FontWeights.Regular};

  &:hover {
    color: ${Colors.Blue60};
  }
`

export const HintIcon = styled(Icon24.HintOutlined)`
  width: 20px;
  height: 20px;
  color: ${Colors.Blue50};

  &:hover {
    color: ${Colors.Blue60};
  }
`

export const TipsContainer = styled.div`
  width: 50px;
  display: flex;
  cursor: pointer;
  align-items: center;
  gap: 4px;

  &:hover {
    ${TipsTitle} {
      color: ${Colors.Blue60};
    }

    ${HintIcon} {
      color: ${Colors.Blue60};
    }
  }
`

export const TooltipQuestionWrapper = styled(Tooltip)`
  & > div {
    width: 360px;
    left: auto;
    right: 7px;

    & > svg {
      left: -15px;
      right: auto;
      color: ${Colors.Neutral90};
    }

    .hint-icon {
      color: ${Colors.Blue50};

      &:hover {
        color: ${Colors.Blue60};
      }
    }
  }

  .tips-container {
    width: auto;
  }
`

export const TooltipQuestionWrapperTablet = styled(Tooltip)`
  & > div {
    width: 355px;
    left: auto;
    right: calc(100% - 230px);

    & > svg {
      left: auto;
      right: -10px;
      color: ${Colors.Neutral90};
    }

    .hint-icon {
      color: ${Colors.Blue50};

      &:hover {
        color: ${Colors.Blue60};
      }
    }
  }

  .tips-container {
    width: auto;
  }
`

export const ToolTipIcon = styled.img`
  width: 50px;
  cursor: pointer;
  height: 20px;
  margin-bottom: 10px;
`
